/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_ExplanationInputs */



/**
* | output |
* | --- |
* | "Members can read this space. Only admins, and the people and teams you grant a tool to, can use its tools. Every call is still confirmed by the person making..." |
*
* @param {Spaces_Tool_Grants_ExplanationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_explanation = /** @type {((inputs?: Spaces_Tool_Grants_ExplanationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_ExplanationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder können diesen Space lesen. Nur Admins und die Personen und Teams, denen du ein Tool freigibst, können seine Tools verwenden. Jeder Aufruf wird weiterhin von der Person bestätigt, die ihn auslöst.")
	return /** @type {LocalizedString} */ ("Members can read this space. Only admins, and the people and teams you grant a tool to, can use its tools. Every call is still confirmed by the person making it.")
});